export default __webpack_public_path__ + "static/img-women-6afec7d3d07328b722caa50e92d74d5d.jpg";